import { render, staticRenderFns } from "./Ag-vmenu.vue?vue&type=template&id=e5dc1e70&scoped=true&"
import script from "./Ag-vmenu.vue?vue&type=script&lang=js&"
export * from "./Ag-vmenu.vue?vue&type=script&lang=js&"
import style0 from "./Ag-vmenu.vue?vue&type=style&index=0&id=e5dc1e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc1e70",
  null
  
)

export default component.exports